(ns minorodata.analytics-models.model
  (:require [mold.core :as m :include-macros true]
            [minorodata.users.model :refer [searchable-user]]))


(declare ->analytics-model-registry ->analytics-model)


;; Catalogue of deployed DS models published to the central registry.
;; Backend vocabulary: a "registry model" (referenced by `registry-model` on a
;; model row). This is read-only reference data, not a per-client entity.
(m/defmodel analytics-model-registry
  {:project-name       [::m/string ::m/req ::m/identity "Model project name (unique identifier)"]
   :version            [::m/string ::m/nilable "Latest registered model version"]
   :task-definition    [::m/string ::m/nilable "Latest build's task definition (family:revision)"]
   :commit-sha         [::m/string ::m/nilable "Latest build's commit SHA"]
   :author             [::m/string ::m/nilable "Model author"]
   :display-name       [::m/string ::m/nilable "Human-readable model name"]
   :description-brief  [::m/string ::m/nilable "Short description"]
   :description-long   [::m/string ::m/nilable "Long description (markdown)"]
   :entry-point        [::m/string ::m/nilable "Entry point reference"]
   :table-definitions  [::m/map ::m/nilable "Input/output table definitions"]
   :custom-ui-blocks   [::m/vector ::m/nilable "Form blocks describing the model's config"]})


;; A per-client analytics model — backend `analytics.model` row, addressed at
;; `/api/analytics-models/:model-id`.
;; Field names mirror the backend `analytics.model` row contract verbatim, and
;; the model declares every row field — the API layer maps the row straight
;; through without selecting or renaming.
(m/defmodel analytics-model
  {:model-id       [::m/string ::m/req ::m/identity "Model ID"]
   :name           [::m/string ::m/nilable "Model name"]
   :status         [::m/string ::m/nilable "active | paused"]
   :registry-model [::m/string ::m/nilable "Registry model project name"]
   :version-label  [::m/string ::m/nilable "Pinned registry model version"]
   :task-definition [::m/string ::m/nilable "Pinned build's task definition (family:revision)"]
   :commit-sha     [::m/string ::m/nilable "Pinned build's commit SHA"]
   :model-params   [::m/map ::m/nilable "Form values keyed by custom-ui-block name"]
   :input-tables   [::m/vector ::m/nilable "Input table names"]
   :output-tables  [::m/vector ::m/nilable "Output table names"]
   :schedule-spec  [::m/map ::m/nilable "Schedule, e.g. {:cron ...}"]
   :description    [::m/string ::m/nilable "Description"]
   :run-mode       [::m/string ::m/nilable "Run mode"]
   :created-at     [::m/string ::m/nilable "Created at ISO timestamp"]
   :updated-at     [::m/string ::m/nilable "Updated at ISO timestamp"]
   :created-by     {::m/type     ::m/ref
                    ::m/ref-type searchable-user
                    ::m/doc      "Related user"}
   :updated-by     {::m/type     ::m/ref
                    ::m/ref-type searchable-user
                    ::m/doc      "Related user"}})
